module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-disabled-datetime-5482eeb00c186c781068134c3ea0aa7e.png";